'use client';

import { useEffect, useState } from 'react';

/**
 * 미디어 쿼리를 감지하는 훅
 * @param query - CSS 미디어 쿼리 문자열 (예: "(min-width: 600px)")
 * @returns {boolean} 미디어 쿼리가 일치하면 true, 아니면 false
 */
export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState<boolean>(false);

  useEffect(() => {
    // SSR 환경에서는 기본값 false
    if (typeof window === 'undefined') {
      return;
    }

    const mediaQuery = window.matchMedia(query);

    // 초기 체크
    setMatches(mediaQuery.matches);

    // 변경 이벤트 리스너
    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    // MediaQueryList.addEventListener는 최신 브라우저에서 지원
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
      return () => {
        mediaQuery.removeEventListener('change', handleChange);
      };
    } else {
      // 구형 브라우저 지원 (addListener/removeListener)
      mediaQuery.addListener(handleChange);
      return () => {
        mediaQuery.removeListener(handleChange);
      };
    }
  }, [query]);

  return matches;
}
